import { apiFetch } from '@/lib/api-client';
import type {
  ReportingScope,
  RawTicket,
  SubtypeCountRow,
  CategoryBreakdownRow,
  ResByTypeRow,
} from '@/components/reporting/types';

export interface ReportingQuery {
  ticketType?: string;
  subtype?: string;
  priority?: string;
  startDate?: string;
  endDate?: string;
}

function toQueryString(q: ReportingQuery): string {
  const params = new URLSearchParams();
  if (q.ticketType) params.set('ticketType', q.ticketType);
  if (q.subtype) params.set('subtype', q.subtype);
  if (q.priority) params.set('priority', q.priority);
  if (q.startDate) params.set('startDate', q.startDate);
  if (q.endDate) params.set('endDate', q.endDate);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export async function fetchReportingScope(q: ReportingQuery) {
  return apiFetch<{ data: ReportingScope }>(`/reporting/scope${toQueryString(q)}`);
}

export async function fetchReportingRawTickets(q: ReportingQuery) {
  return apiFetch<{ data: RawTicket[] }>(`/reporting/raw-tickets${toQueryString(q)}`);
}

export async function fetchReportingSubtypes(ticketType: string) {
  return apiFetch<{ data: SubtypeCountRow[] }>(`/reporting/subtypes/${ticketType}`);
}

export async function fetchReportingCategories() {
  return apiFetch<{ data: CategoryBreakdownRow[] }>('/reporting/categories');
}

export async function fetchReportingResolutionByType() {
  return apiFetch<{ data: ResByTypeRow[] }>('/reporting/resolution-by-type');
}
